export const sessionStorageItems = {
  lastRefresh: 'last_refresh',
  graphStrokeColorKey: 'graph-stroke-color',
  stagePreviewMode: 'stage_preview_mode',
  scrollHintKeys: 'scroll_hint_keys',
}
